import { Kbd } from "./kbd";
import { cn } from "@/lib/utils";

interface SearchHintProps {
  className?: string;
}

/**
 * Visual "Search ⌘K" hint shown in list-page header actions. Aria-hidden
 * because the actual shortcut is bound globally by the command palette;
 * this is purely affordance. Mirrors `.search-hint` from
 * mockup--opportunity-list.css:90-105.
 */
export function SearchHint({ className }: SearchHintProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "min-w-[240px] inline-flex items-center gap-2 px-3 py-1.5",
        "rounded-[var(--radius-sm)] border border-[color:var(--color-border)]",
        "bg-[color:var(--color-surface)] text-[color:var(--color-text-md)]",
        "typo-body select-none",
        className,
      )}
    >
      <span>Search</span>
      <Kbd className="ml-auto">⌘K</Kbd>
    </span>
  );
}
